<div class="page-content">
    <div class="page-header">
        <h1> Analyse des temps passés </h1>
         <div class="page-description">
            <ed-select
                [ngModel]="year"
                [options]="yearsOptions"
                (ngModelChange)="onChangeYear($event)"
            >
            </ed-select>    
        </div>
    </div>

    <div class="page-body">
       
     
        <div class="row g-4">
                <div class="col-sm-12">
                    <chart-card
                        id="Dashboard-entries-typologies-chart"
                        title="Temps passé par typologies"
                        [error]="timeEntriesByTypologies.length === 0"
                        [isLoading]="isLoading"
                        [series]="typologiesSeries"
                        [stacked]="true"
                        [dataLabels]="typologiesDataLabels"                
                        [xaxisCategories]="typologiesXaxisCategories"
                        xaxisType="datetime"
                        type="bar"
                        [yaxis]="typologiesYaxis"
                        [precision]="1"
                        [yaxisPrecision]="1"
                        [stacked]="true"
                        class="h-100"></chart-card>
                </div>
        </div>
        
        <br/>
        <div class="row g-4">
            <div class="col-sm-12">
                 <table-card 
                        title="Détail par activités"
                        [sortInfo]="{field: 'total', order: -1}"
                        [isLoading]="isLoading" 
                        [dataSource]="activitiesData" 
                        [displayedColumns]="activitiesColumns"
                        >
                    </table-card>
            </div>
        </div>
    
        <br/>
    </div>
</div>